import React from "react";
import { Typography, makeStyles, Grid, Hidden } from "@material-ui/core";
import * as Yup from "yup";
import { FunnelCardContainer } from "ui/funnelCardContainer/FunnelCardContainer";
import AddressForm from "components/funnel/steps/funnelStepAddress/AddressForm";
import { Formik, Form } from "formik";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Button from "components/design-system/atoms/Button";
const ERROR_MESSAGE = "Merci de remplir ce champ";

const AddressSchema = Yup.object().shape({
  street: Yup.string().required("Merci de renseigner votre adresse"),
  zipcode: Yup.number()
    .typeError("Le code postal doit contenir 5 chiffres")
    .required("Merci de renseigner votre code postal"),
  city: Yup.string().required("Merci de renseigner votre ville"),
  informations: Yup.string(),
  isBuilding: Yup.boolean().required(ERROR_MESSAGE),
  elevator: Yup.boolean().when("isBuilding", {
    is: true,
    then: Yup.boolean().required(ERROR_MESSAGE),
  }),
  floor: Yup.number().when("isBuilding", {
    is: true,
    then: Yup.number()
      .typeError("Veuillez saisir un chiffre. Si vous habitez au rez-de-chaussée, saisissez 0 !")
      .required("Merci de renseigner votre étage"),
  }),
  difficulties: Yup.string().max(300, "La description complémentaire doit contenir au maximum 300 caractères"),
});

export default function FunnelStepAddress({
  handleSubmit,
  handlePrevious,
  street,
  city,
  informations,
  zipcode,
  isBuilding,
  elevator,
  floor,
  difficulties,
  error,
  full_address,
}) {
  const classes = useStyles();
  return (
    <Formik
      initialValues={{
        full_address: full_address || "",
        address_input_text: full_address || "",
        street: street || "",
        city: city || "",
        informations: informations || "",
        zipcode: zipcode || "",
        isBuilding: isBuilding || "",
        elevator: elevator || "",
        floor: floor || 0,
        difficulties: difficulties || "",
      }}
      validationSchema={AddressSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <FunnelCardContainer>
            <Typography color="secondary" variant="h2">
              Informations supplémentaires
            </Typography>
            <AddressForm />
          </FunnelCardContainer>
          {error && (
            <Grid item className={classes.error}>
              <Grid item>
                <Typography color="error">{error}</Typography>
              </Grid>
            </Grid>
          )}
          <Grid container justify="center" className={classes.legalInformationBlock}>
            <Grid item>
              <Typography variant="subtitle2">
                Conformément aux dispositions en vigueur, en cliquant sur “confirmer mon rendez-vous” je consens céder
                mon (mes) appareil(s) à Murfy SAS
              </Typography>
            </Grid>
          </Grid>
          <Grid container item justify="space-between" className={classes.buttons}>
            <Grid item>
              <Button startIcon={<ArrowBackIcon />} version="invisible" onClick={handlePrevious}>
                Retour
              </Button>
            </Grid>

            <Grid item>
              <Button disabled={isSubmitting} version="fancy" type="submit">
                <Hidden smDown implementation="css">
                  Confirmer mon rendez-vous
                </Hidden>
                <Hidden mdUp implementation="css">
                  Confirmer
                </Hidden>
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}

const useStyles = makeStyles((theme) => ({
  error: {
    marginTop: theme.spacing(2),
  },
  funnelInformation: {
    marginBottom: 100,
  },
  description: {
    marginTop: theme.spacing(),
    lineHeight: "140%",
  },
  legalInformationBlock: {
    marginTop: theme.spacing(2),
  },
  buttons: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      zIndex: 5,
      position: "fixed",
      margin: 0,
      bottom: 0,
      left: 0,
      padding: theme.spacing(1),
      backgroundColor: theme.palette.common.white,
      borderTop: "1px solid #D7D7D7",
    },
  },
}));
